import * as React from "react";
import { StoreVisits } from "../../../constants";
import "./style.scss";

interface StoreNameCellProps {
  name: string;
  address: string;
}

export const StoreNameCell = (props: StoreNameCellProps): any => {
  return (
    <div className="top-stores-table-name-cell">
      <span className="name-row">{props.name}</span>
      <span className="address-row">{props.address}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/components/TopStoresTable/StoreNameCell/index.tsx